import { isStandaloneGift } from "@store/utils";

import type { Product } from "@jti/magento";

export const isRegularGift = (item: Product) => {
  return item.isGift && !isStandaloneGift(item);
};
